import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

const projectOverviewSectionStyles = {
  contentWrapper: (): SystemStyleObject<Theme> => ({
    display: "grid",
    gridTemplateColumns: { xs: "1fr", lg: "1fr 1fr" },
    gap: { xs: 4, lg: 8 },
    mt: 6,
    alignItems: "start",
  }),
  tabsWrapper: (): SystemStyleObject<Theme> => ({
    display: "flex",
    flexDirection: "column",
    gap: { xs: 2, lg: 0 },
  }),
  accordion: (theme: Theme): SystemStyleObject<Theme> => ({
    background: "transparent",
    boxShadow: "none",
    borderBottom: `1px solid ${theme.palette.divider}`,

    "&:before": {
      display: "none",
    },

    "&.Mui-expanded": {
      margin: 0,
    },
  }),
  accordionSummary: (): SystemStyleObject<Theme> => ({
    p: 0,
    py: { xs: 2, lg: 3 },
    display: "flex",
    alignItems: "center",
    gap: 3,
    minHeight: "auto !important",

    "& .MuiAccordionSummary-content": {
      margin: 0,
      display: "flex",
      alignItems: "center",
      gap: 3,
    },

    "& .MuiAccordionSummary-expandIconWrapper": {
      display: { lg: "none" },
    },
  }),
  accordionDetails: (): SystemStyleObject<Theme> => ({
    p: 0,
    pb: { xs: 3, lg: 4 },
    display: "flex",
    flexDirection: "column",
    gap: 3,
  }),
  bar: (
    theme: Theme,
    { isActive }: { isActive: boolean },
  ): SystemStyleObject<Theme> => ({
    width: 4,
    height: 40,
    backgroundColor: isActive
      ? theme.palette.secondary.main
      : theme.palette.divider,
    borderRadius: 1,
    transition: "background-color 0.3s ease",
  }),
  title: (
    theme: Theme,
    { isActive }: { isActive: boolean },
  ): SystemStyleObject<Theme> => ({
    fontSize: { xs: 24, md: 32, lg: 36 },
    fontWeight: 700,
    lineHeight: 1.2,
    color: isActive ? theme.palette.text.primary : theme.palette.grey[600],
    transition: "color 0.3s ease",
    cursor: "pointer",
  }),
  contentBox: (): SystemStyleObject<Theme> => ({
    display: "flex",
    flexDirection: "column",
    gap: 2,
  }),
  text: (): SystemStyleObject<Theme> => ({
    fontSize: { xs: 14, md: 16 },
    lineHeight: 1.7,
    color: "grey.400",
    fontWeight: 400,
  }),
  mediaWrapper: (): SystemStyleObject<Theme> => ({
    position: "sticky",
    top: 100,
    width: "100%",
    height: "fit-content",
  }),
};

export default projectOverviewSectionStyles;
